<app-button
  [matTooltip]="'subscription.mail_sales.tooltip'|translate"
  matTooltipPosition="above"
  (onClick)="talkToSales()"
  icon="chat_bubble_outline"
  buttonType="mat-stroked-button">{{'subscription.talk_to_sales'|translate}}</app-button>
